import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  TextField,
  InputAdornment,
  Button,
  ButtonGroup,
} from '@mui/material';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import {
  DetailDeliveryOrderHistory,
  // eslint-disable-next-line import/no-unresolved
} from 'components/Report/index';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import VehicleScheduleHistoryTable from '../../components/Table/TMS/VehicleScheduleHistoryTable';

const VehicleScheduleHistory = ({ title, subtitle }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const vehicleSchedule = useSelector((state) => state.vehicleSchedule);
  const information = useSelector((state) => state.information);
  const [scheduleType, setScheduleType] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(undefined);

  const getVehicleSchedule = () =>
    dispatch(
      actions.vehicleScheduleAll({
        name,
        page,
        size,
        scheduleType,
        history: true,
      }),
    );

  useEffect(() => {
    getVehicleSchedule();
    return () => {};
  }, [name, page, size, scheduleType]);

  useEffect(() => {
    setTotal(vehicleSchedule?.total);
    return () => {};
  }, [vehicleSchedule]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 700);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const tableProps = {
    page,
    size,
    total,
    handleChangePage: (evnet, newPage) => {
      setPage(newPage + 1);
    },
    handleChangeRowsPerPage: (event) => {
      setSize(event.target.value);
      setPage(1);
    },
    handleToInfoPage: (id) => {
      history.push(`/tms/vehicle-schedule/detail/${id}`);
    },
    handlePrintPdfDeliveryOrder: async (row, vehicleSchedule) => {
      await await DetailDeliveryOrderHistory(row, information, vehicleSchedule);
    },
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const renderSearchType = () => (
    <div className="flex flex-wrap mb-4">
      <ButtonGroup
        variant="outlined"
        aria-label="outlined button group"
        color="gray"
      >
        <Button onClick={() => setScheduleType('IMPORT')}>
          <div className="text-black">IMPORT</div>
        </Button>
        <Button onClick={() => setScheduleType('EXPORT')}>
          <div className="text-black">EXPORT</div>
        </Button>
        <Button onClick={() => setScheduleType('')}>
          <div className="text-black">ALL</div>
        </Button>
      </ButtonGroup>
    </div>
  );

  const renderSearch = () => (
    <Card>
      <div className="p-4 flex flex-row">
        <div className="w-full md:w-1/2">
          <TextField
            label="ค้นหา"
            fullWidth
            size="small"
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search" />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
    </Card>
  );

  const renderTable = () => (
    <div className="my-2">
      <VehicleScheduleHistoryTable
        vehicleSchedule={vehicleSchedule}
        {...tableProps}
      />
    </div>
  );

  if (vehicleSchedule.isLoading) {
    return <Loading />;
  }

  if (!vehicleSchedule.isLoading && vehicleSchedule.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex justify-start">{renderSearchType()}</div>
        {renderSearch()}
        {renderTable()}
      </div>
    );
  }
  return <Error />;
};

VehicleScheduleHistory.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

VehicleScheduleHistory.defaultProps = {
  title: '',
  subtitle: '',
};

export default VehicleScheduleHistory;
